import AbstractClass from './HomePageAbstractServices';
import { AwaitResponse } from '../../utils/MockUtils';

export default class HomePageServices extends AbstractClass {
  static getPWReferenceData() {
    return AwaitResponse({
      showAlert: true,
      alertText: {
        informationText: '<p>Important notice alert, Lorem ipsum dolor sit amet, consectetur adipiscing elit. <a href="#">Find out more by visiting our page.</a></p>',
      },
      carousels: [
        {
          headline: 'Everyday Bronze Plus',
          description: 'Affordable hospital cover that’s anything but basic.',
          toUrl: '~/Health-Insurance/Get-a-Quote',
          imageUrl: '/assets/public/images/carousel_980x362_1.jpg',
          imageAltText: 'pic1',
          buttonText: 'Get a quote',
        },
        {
          headline: 'Register Now!',
          description: 'Remember to register now for the member portal',
          toUrl: '',
          imageUrl: '/assets/public/images/carousel_980x362_2.jpg',
          imageAltText: 'pic2',
          buttonText: 'Register Now!',
        },
        {
          headline: 'Stay covered with Defence Health.',
          description: "With Defence Health, you're in safe hands",
          toUrl: '',
          imageUrl: '/assets/public/images/carousel_980x362_3.jpg',
          imageAltText: 'pic3',
          buttonText: '',
        },
        {
          headline: 'Work with us',
          description: 'At Defence Health family doesn’t stop with the members we serve. Our people are part of the family too.',
          toUrl: '~/About/Work-With-Us',
          imageUrl: '/assets/public/images/carousel_980x362_4.jpg',
          imageAltText: 'pic4',
          buttonText: 'Read More',
        },
        {
          headline: 'There’s more for members at Defence Health.',
          description: 'Log in to your secure membership portal to manag',
          toUrl: '',
          imageUrl: '/assets/public/images/carousel_980x362_5.jpg',
          imageAltText: 'pic5',
          buttonText: 'Sign in / Register',
        },
      ],
    });
  }

  // Reference data for Member Portal
  static getMPReferenceData() {
    return AwaitResponse({
      showAlert: false,
      alertText: {
        informationText: '',
      },
      welcomeBannerImage: {
        informationText: '~/assets/public/images/WelcomeBanner.jpeg',
      },
      showCarousel: true,
      carousels: [
        {
          headline: 'test',
          description: '',
          toUrl: '',
          imageUrl: '~/getmedia/cac3ef3b-733c-417e-9b23-36464193573f/blogimage1.jpg?width=1024&height=682&ext=.jpg',
          imageAltText: 'test',
          buttonText: '',
        },
      ],
      topTasksOptions: [
        {
          title: 'Make a Claim',
          imageUrl: '/assets/public/images/mp-icon-make-a-claim.svg?ext=.svg',
          imageAltText: 'image',
          toUrl: '~/$memberNumber$/my-claims/claims/make-a-claim',
        },
        {
          title: 'Edit payment details',
          imageUrl: '/assets/public/images/mp-icon-tax-statements.svg?ext=.svg',
          imageAltText: 'payment',
          toUrl: '~/$memberNumber$/Payment-Selection',
        },
        {
          title: 'View your claims',
          imageUrl: '/assets/public/images/mp-icon-view-claims.svg?ext=.svg',
          imageAltText: 'claims',
          toUrl: '~/$memberNumber$/my-claims/claims',
        },
        {
          title: 'View your limits & usage',
          imageUrl: '/assets/public/images/mp-icon-limits-usage.svg?ext=.svg',
          imageAltText: 'limits',
          toUrl: '~/$memberNumber$/my-claims/Limits-and-usage',
        },
        {
          title: 'Make a payment',
          imageUrl: '/assets/public/images/mp-icon-make-a-payment.svg?ext=.svg',
          imageAltText: 'make-a-payment',
          toUrl: '~/$memberNumber$/my-cover/payments/make-a-payment',
        },
        {
          title: 'View documents',
          imageUrl: '/assets/public/images/mp-icon-documents.svg?ext=.svg',
          imageAltText: 'benefiits',
          toUrl: '~/$memberNumber$/my-cover/my-documents',
        },
      ],
      topTasksInformationText: {
        informationText:
          'If you need to update personal details, please email or call us on <a href="tel://1800335425">1800 335 425</a>.​​<br />\r\n<br />\r\nTax statements are available under My Cover in the menu at the top of the page.​<br />\r\n<br />\r\nWe have a large backlog of claims and sincerely apologise for the delay in getting benefit payments to members. ​<br />\r\n<br />\r\nFor faster payment, some claims can be made through the Member Portal. Online claims through the Member Portal are usually paid within two business days. Snap and send from your mobile will take longer than claiming online.',
      },
      underMaintenance: false,
    });
  }

  static getMembershipInfo() {
    return AwaitResponse({
      memberNumber: 'BC2007',
      productName: 'Advantage Hospital Silver Plus & Essentials Extras',
      productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/AdvantageHospitalSilverPlus_ValueExtras.pdf',
      datePaidTo: '2025-11-10',
      nextContributionDate: '2023-11-27',
      composition: 'couple',
      frequency: 'monthly',
      coverStartDate: '2022-09-20',
      policyStatus: 'Active',
      // policyStatus: 'SUSPENDED', // Enable these to mock suspended policy
      // suspensionStartDate: '2023-09-27',
      // resumptionStartDate: '2023-11-27',
    });
  }
}
